import MainPage from './main-page.container';

export default MainPage;